module.exports = __webpack_public_path__ + "img/walker-half.66e856bf.jpg";